module.exports = __webpack_public_path__ + "img/icon-cart-grey.66923714.svg";